// src/components/reports/SectionAbo.tsx

import { Collapse } from '@mui/material'

import {
  AboRecipients,
  AboutAboRecipients,
  AboutAbos,
  AddAboRecipient,
} from '..'

type Props = {
  mode: number
  data: any[]
  setRecipientsList: (data: any) => void
}

export const SectionAbo = ({ mode, data, setRecipientsList }: Props) => {
  const MODE_ABO = 1

  const onAdd = email => setRecipientsList(prev => [...prev, { email }])
  const onDelete = data => setRecipientsList(data)

  return (
    <Collapse in={mode === MODE_ABO}>
      <AboutAbos sx={{ my: 2 }} />
      <AboRecipients data={data} onDelete={onDelete} />
      <AboutAboRecipients sx={{ my: 2 }} />
      <AddAboRecipient onAdd={onAdd} />
    </Collapse>
  )
}
